// GENERATED FILE - DO NOT MODIFY

export enum UserPreferredWorkTypeDto {
    Office = "Office",
    Remote = "Remote",
}